export default __webpack_public_path__ + "static/media/Email-icon.d7d116f3.svg";